import { createSelector } from 'reselect';
import { WellGuideLinkVariants } from '@zocdoc/components/src/Layout/Header/constants';
import { AB_KEY } from './constants';
import {
    NEW_EXISTING_PROFILE_TOGGLE,
    PINA_HAMBURGER_MENU_WELL_GUIDE_LINK,
    SALP_BLOCK,
    SHOW_FACETED_SEARCHBAR,
    SHOW_FIND_SIMILAR_DOCTORS,
    SHOW_NEW_SIDE_BAR,
    SHOW_REVIEW_COUNT,
    TELEHEALTH_LINK_TO_BOOKING,
    TELEHEALTH_LINK_TO_PROFILE,
    VARIANT_ON,
    VARIANT_SHOW_TOGGLE,
    WELL_GUIDE_HEADER_NAVIGATION,
    SPO_USE_SPOOM,
    PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER,
} from './experiments';
import { getThemeParameters } from '../theme';
import isZocdocBrand from '../../utils/isZocdocBrand';
import { useDropdownHeaderChevron } from '../../Home/experiments/insurancePickerUseDropdownHeaderChevron';
import { get } from 'lodash';

export const getABParameters = state => state[AB_KEY];

export const showFindSimilarDoctors = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_FIND_SIMILAR_DOCTORS.experimentId] === VARIANT_ON
            && isZocdocBrand(theme.directoryId);
    }
);

export const showFacetedSearchBar = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_FACETED_SEARCHBAR.experimentId] === VARIANT_ON
            && isZocdocBrand(theme.directoryId);
    },
);

export const showReviewCount = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[SHOW_REVIEW_COUNT.experimentId] === VARIANT_ON
            && isZocdocBrand(theme.directoryId);
    },
);

export const showNewExistingToggle = createSelector(
    [getABParameters, getThemeParameters],
    (ab, theme) => {
        return ab[NEW_EXISTING_PROFILE_TOGGLE.experimentId] === VARIANT_SHOW_TOGGLE
            && isZocdocBrand(theme.directoryId);
    },
);

export const showSalpBlock = createSelector(
    [getABParameters],
    ab => ab[SALP_BLOCK.experimentId] === VARIANT_ON,
);

export const showWellGuideLink = createSelector(
    [getABParameters],
    ab => ab[WELL_GUIDE_HEADER_NAVIGATION.experimentId] === VARIANT_ON,
);

export const shouldPersistChosenCarrier = createSelector(
    getABParameters,
    ab => ab[PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER.experimentId] === VARIANT_ON,
);

export const useChevronDropdownHeader = createSelector(
    getABParameters,
    ab => useDropdownHeaderChevron(ab),
);

export const shouldLinkTelehealthProfile = createSelector(
    [getABParameters],
    ab => ab[TELEHEALTH_LINK_TO_PROFILE.experimentId] === VARIANT_ON,
);

export const getWellGuideLinkVariantFromProps = ({ ab }) =>
    get(ab, PINA_HAMBURGER_MENU_WELL_GUIDE_LINK.experimentId, WellGuideLinkVariants.OFF);

export const getWellGuideLinkVariant = createSelector(
    getABParameters,
    ab => ab[PINA_HAMBURGER_MENU_WELL_GUIDE_LINK.experimentId],
);

export const shouldLinkTelehealthBooking = createSelector(
    [getABParameters],
    ab => ab[TELEHEALTH_LINK_TO_BOOKING.experimentId] === VARIANT_ON,
);

export const shouldShowNewSidebar = createSelector(
    [getABParameters],
    ab => ab[SHOW_NEW_SIDE_BAR.experimentId] === VARIANT_ON,
);

export const shouldUseSpoom = createSelector(
    [getABParameters],
    ab => ab[SPO_USE_SPOOM.experimentId] === VARIANT_ON,
);
